<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>خطوط الموظف</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع خطوط الموظف
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                                <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                                 {{success}}
                              </div>
                              <div class='col-lg-3 col-md-6 col-sm-6'>
                                <div class="form-group">
                                    <label>الفرع</label>
                                    <select  @change='brancheData($event.target.value)' class="form-control" style="padding: 0px" v-model="branche">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-6 col-sm-6'>
                                <div class="form-group">
                                    <label>الموظف</label>
                                    <select class="form-control" style="padding: 0px" v-model="emp">
                                      <option v-for="(item) in emps" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-6 col-sm-6'>
                                <div class="form-group">
                                    <label>الخط</label>
                                    <select class="form-control" style="padding: 0px" v-model="itinerarie">
                                      <option v-for="item in itineraries" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                                </div>
                              </div>
                              <div v-show="$per.value.saveEmpItineraries"  class='col-lg-3 col-md-6 col-sm-6'>
                                <div class="form-group">
                                    <label>&nbsp;</label>
                                    <button @click='saveData()' type='button' class='btn btn-outline btn-primary btn-md  btn-block'  data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة </b>
                                    </button>
                                </div>
                              </div>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>الموظف</th>
                                          <th style='text-align: center'>الخط</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.emp_name}}</td>
                                          <td align='center'>{{record.itinerar_name}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button v-show="$per.value.deleteEmpItineraries" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'emp_itineraries',
  data () {
    return {
      validationErrors: '',
      records: {},
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      itineraries: {},
      itinerarie: '',
      branches: {},
      branche: '',
      emps: {},
      emp: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branche = this.branches[0].id
    this.brancheData(this.branche)
  },
  methods: {
    brancheData (id) {
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      this.itineraries = JSON.parse(JSON.stringify(this.branches[i].itineraries))
      this.itinerarie = ''
      // ---------------------------------------
      this.GetData()
      // ----------------------------------------
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getBranchEmp', {
        token: localStorage.getItem('token'),
        branch_id: this.branche
      })
        .then(({ data }) => {
          this.emps = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },

    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getEmpItineraries', {
        token: localStorage.getItem('token'),
        branch_id: this.branche
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveEmpItineraries', {
        token: localStorage.getItem('token'),
        itinerary_id: this.itinerarie,
        user_id: this.emp,
        branch_id: this.branche
      })
        .then(res => {
          this.isLoadingSave = false
          this.records = res.data
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteEmpItineraries', {
        token: localStorage.getItem('token'),
        id: recID,
        branch_id: this.branche
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/EmpItineraries.vue